import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api/api';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setMessage('');
    try {
      // Assuming there's a POST /api/auth/forgot-password endpoint
      await api.post('/auth/forgot-password', { email });
      setMessage('If an account exists with that email, a password reset link has been sent.');
    } catch (err) {
      setError(err.response?.data?.message || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page-wrapper">
      <div className="auth-card">
        <div className="auth-header">
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '0.75rem',
            marginBottom: '1.5rem'
          }}>
            <div style={{
              width: '48px',
              height: '48px',
              backgroundColor: 'white',
              borderRadius: '10px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '4px',
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
              flexShrink: 0
            }}>
              <img 
                src="/Media_Logo.png" 
                alt="Delta Media" 
                style={{ 
                  width: '100%', 
                  height: '100%', 
                  objectFit: 'contain',
                  borderRadius: '6px'
                }} 
              />
            </div>
            <div className="auth-brand" style={{ marginBottom: 0 }}>DELTA MEDIA</div>
          </div>
          <h2>Reset Password</h2>
          <p>Enter your email to receive a reset link</p>
        </div>

        {!message ? (
          <form onSubmit={handleSubmit} className="auth-form">
            <div className="auth-field">
              <label>Email Address</label>
              <input
                className="auth-input"
                type="email"
                placeholder="name@company.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            {error && <div className="auth-error">{error}</div>}

            <button className="auth-submit-btn" type="submit" disabled={loading}>
              {loading ? 'Sending Link...' : 'Send Reset Link'}
            </button>
          </form>
        ) : (
          <div style={{ textAlign: 'center' }}>
            <div style={{ background: '#dcfce7', color: '#166534', padding: '1rem', borderRadius: '0.75rem', marginBottom: '1.5rem', fontSize: '0.9rem', fontWeight: 500 }}>
              {message}
            </div>
            <button className="auth-submit-btn" style={{ width: '100%' }} onClick={() => navigate('/login')}>
              Back to Login
            </button>
          </div>
        )}

        <div className="auth-footer">
          Remember your password?{' '}
          <span className="auth-link" onClick={() => navigate('/login')}>
            Sign In
          </span>
        </div>
      </div>
    </div>
  );
}

